import { render, staticRenderFns } from "./AcademyLearningMapProblems.vue?vue&type=template&id=0840adb7&scoped=true&lang=pug&"
import script from "./AcademyLearningMapProblems.vue?vue&type=script&lang=ts&"
export * from "./AcademyLearningMapProblems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0840adb7",
  null
  
)

export default component.exports